import getAbsoluteHeight from '../util/absoluteHeight';

const collapseSections = document.querySelectorAll('.u-section-collapse');

if (collapseSections) {
  collapseSections.forEach(section => {
    const sectionInner = section.querySelector('.c-widget__inner');
    const trigger = section.querySelector('.u-trigger');

    window.addEventListener('DOMContentLoaded', () => {
      const sectionInnerHeight = getAbsoluteHeight(sectionInner);
      const { collapseHeight } = section.dataset;

      sectionInner.style.height = `${
        collapseHeight
          ? sectionInnerHeight * (collapseHeight / 100)
          : sectionInnerHeight - sectionInnerHeight / 2
      }px`;

      trigger.addEventListener('click', () => {
        sectionInner.style.height = `${sectionInnerHeight}px`;
        sectionInner.classList.add('is-opened');
        trigger.style.display = 'none';
      });
    });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/collapse.js